import {Fade} from "react-awesome-reveal";

const PaginationHeader = ({steps, activeStep}) => {
  return (
    <Fade triggerOnce delay={200} duration={1000}>
      <header className="signup_pagination cs_row">
        {steps?.map((v, i) => (
          <div
            key={i}
            className={`paging_item ${activeStep === i ? " active" : " "}`}
          ></div>
        ))}
      </header>
    </Fade>
  );
};

export default PaginationHeader;
